function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPushchair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.082031 10.5 C 11.011719 10.5 10.941406 10.507812 10.875 10.519531 L 8.890625 7.972656 L 11.082031 7.972656 L 11.082031 6.804688 L 7.980469 6.804688 L 6.960938 5.5 C 7.472656 4.988281 8.644531 3.816406 9.507812 2.953125 C 8.226562 1.671875 6.1875 1.613281 4.835938 2.769531 L 3.585938 1.167969 L 1.75 1.167969 L 1.75 2.332031 L 3.015625 2.332031 L 4.265625 3.941406 L 5.582031 9.859375 L 5.070312 10.519531 C 5.003906 10.507812 4.933594 10.5 4.859375 10.5 C 4.21875 10.5 3.695312 11.023438 3.695312 11.667969 C 3.695312 12.3125 4.21875 12.832031 4.859375 12.832031 C 5.503906 12.832031 6.027344 12.3125 6.027344 11.667969 C 6.027344 11.527344 6.003906 11.398438 5.960938 11.273438 L 6.867188 10.109375 L 9.078125 10.109375 L 9.984375 11.273438 C 9.941406 11.398438 9.917969 11.527344 9.917969 11.667969 C 9.917969 12.3125 10.4375 12.832031 11.082031 12.832031 C 11.726562 12.832031 12.25 12.3125 12.25 11.667969 C 12.25 11.023438 11.726562 10.5 11.082031 10.5 Z M 11.082031 10.5 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushchair);
export default __webpack_public_path__ + "static/media/pushchair.17d52ce6a49f8a61e7947baa25abaf85.svg";
export { ForwardRef as ReactComponent };